import React from 'react';

import { Box } from '@wds/box';
import { Typography } from '@wds/typography';
import { Slide } from '@wds/motion';

import PropTypes from 'prop-types';
import STRINGS from '../constants';
import RecoveryCodes from "./RecoveryCodes";

const EnrollmentComplete = (props) => {
	const {
		currentPage,
		isLoaded,
		context,
		error,
		isSliding,
		setIsSliding,
		handleOnFinish,
		finishBtnTxt,
	} = props;

	return (
		<Slide
			in={isLoaded && currentPage === 'enrollment-complete'}
			speed={currentPage === 'enrollment-complete' ? 'slow' : undefined}
			timeout={currentPage === 'enrollment-complete' ? undefined : 150}
			direction='right'
			onEnter={() => setIsSliding(true)}
			onExited={() => setIsSliding(false)}
			alwaysRenderContent
		>
			<Box
				display='flex'
				flexDirection='column'
				gap={4}
				style={{ position: isSliding ? 'absolute' : 'static', width: '100%' }}
				mb={6}
			>
				<Box
					display='flex'
					flexDirection='column'
					justifyContent='center'
					alignItems='center'
					gap={4}
				>
					<Box>
						<Typography variant='sectionTitle' weight='medium'>
						{STRINGS.allSet}
						</Typography>
						<Typography component='p' variant='bodySm'>
							{STRINGS.whenYouLoginMFA}
							{' '}
							<Typography
								component='a'
								variant='link'
								href={reverse('mfa-learn-more')}
								target='_blank'
								rel='noopener noreferrer'
							>
								{STRINGS.learnMoreAboutManagingMFA}
							</Typography>
						</Typography>
					</Box>
				</Box>
				<RecoveryCodes
					codes={context.recovery_codes}
					error={error}
					handleOnFinish={handleOnFinish}
					finishBtnTxt={finishBtnTxt}
				/>
			</Box>
		</Slide>
	);
};

EnrollmentComplete.propTypes = {
	isLoaded: PropTypes.bool.isRequired,
	context: PropTypes.object.isRequired,
	isSliding: PropTypes.bool.isRequired,
	setIsSliding: PropTypes.func.isRequired,
	currentPage: PropTypes.string.isRequired,
	handleOnFinish: PropTypes.func.isRequired,
	finishBtnTxt: PropTypes.string.isRequired,
};

export default EnrollmentComplete;
